module.exports = __webpack_public_path__ + "img/img3.19f3157d.png";